import { push } from 'redux-router';
import { accountRoute } from '../routes';

export const ROLE_ACCOUNT = 'ACCOUNT'; //simple account role
export const ROLE_MEMBER = 'MEMBER';
export const ROLE_ADMIN = 'ADMIN';
export const ROLE_JUDGE = 'JUDGE';
export const ROLE_JUDGE_FOTD = 'JUDGE_FOTD';
export const ROLE_JUDGE_FOTM = 'JUDGE_FOTM';
export const ROLE_JUDGE_FOTY = 'JUDGE_FOTY';
export const ROLE_JUDGE_TCEA = 'JUDGE_TCEA';
export const FWA_ADMIN = 'FWA_ADMIN';

function getProperty(user, property, defaultValue = '') {
	if (user && user.hasOwnProperty(property)) {
		return user[property];
	} else {
		return defaultValue;
	}
}

let _user = {};

export default class Auth {
	constructor(userObj) {
		this.setIdentity(userObj);
	}

	get id() {
		return getProperty(_user, 'id', false);
	}

	get name() {
		return getProperty(_user, 'name');
	}

	get email() {
		return getProperty(_user, 'email');
	}

	get msg() {
		return getProperty(_user, 'message');
	}

	get roles() {
		return getProperty(_user, 'roles', []);
	}

	get profile() {
		return getProperty(_user, 'profiles');
	}

	get editorials() {
		return getProperty(_user, 'editorials');
	}

	get hasPassword() {
		return getProperty(_user, 'hasPassword');
	}

	get receiveNewsletter() {
		return getProperty(_user, 'receiveNewsletter');
	}

	canHas(rolesToCheck = []) {
		if (typeof rolesToCheck === 'string') {
			rolesToCheck = [rolesToCheck];
		}

		for (let i = 0; i < rolesToCheck.length; i++) {
			for (let k = 0; k < this.roles.length; k++) {
				if (this.roles[k] === rolesToCheck[i]) {
					return true;
				}
			}
		}

		return false;
	}

	setIdentity(userObj) {
		_user = userObj;

		this._id = userObj.id;
		this._name = userObj.name;
		this._message = userObj.message || '';

		return this;
	}

	isLoggedIn() {
		return !!getProperty(_user, 'id', false);
	}
}

export function redirectToPathIf(dispatch, pathname, condition, returnTo = false) {
	if (!condition) {
		return false;
	}

	let query = {};
	if (returnTo && typeof returnTo === 'object') {
		query = returnTo;
	} else if (returnTo && typeof returnTo === 'string') {
		query.returnTo = returnTo;
	} else if (returnTo && typeof returnTo !== 'object') {
		query = { returnTo: window.location.pathname };
	}

	// console.log('URL: ', pathname, 'RETURN:', query.returnTo);

	dispatch(
		push({
			pathname: pathname,
			query: query,
		})
	);
}

export function redirectToAccountIfNoProfile(dispatch, user) {
	if (user && !user.profile) {
		dispatch(
			push({
				pathname: accountRoute('/settings'),
				query: { returnTo: window.location.pathname },
			})
		);
	} else if (user && !user.isLoggedIn()) {
		dispatch(
			push({
				pathname: accountRoute('/login'),
				query: { returnTo: window.location.pathname },
			})
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/utils/authorization.js
 **/